/**
 * Adebify metric keys, screen catalogs, and cell-formatting metadata.
 *
 * Keys must match adebify/jug-api/src/layers/adebify/query_builder/metric_registry.py.
 * Screen-visible lists follow adebify/docs/要件.md (product analysis §359-386,
 * LTV detail §113 and 付録C).
 */

// --- Product analysis 項目切替 catalog ---

const PRODUCT_ANALYSIS_METRICS = [
  { key: 'impressions', label: '表示回数', isAdMetric: true, defaultChecked: true },
  { key: 'clicks', label: 'クリック数', isAdMetric: true, defaultChecked: true },
  { key: 'ctr', label: 'CTR', isAdMetric: true },

  { key: 'cv_total', label: 'CV（合計）', defaultChecked: true },
  { key: 'new_cv', label: '新規CV', defaultChecked: true },
  { key: 'repeat_cv', label: 'リピートCV', defaultChecked: true },
  { key: 'cvr', label: 'CVR', isAdMetric: true },

  { key: 'indirect2', label: '間接効果2', isAdMetric: true },
  { key: 'indirect3', label: '間接効果3', isAdMetric: true },
  { key: 'indirect4', label: '間接効果4', isAdMetric: true },
  { key: 'indirect5', label: '間接効果5', isAdMetric: true },
  { key: 'indirect6', label: '間接効果6', isAdMetric: true },
  { key: 'indirect7', label: '間接効果7', isAdMetric: true },
  { key: 'indirect8', label: '間接効果8', isAdMetric: true },
  { key: 'indirect9', label: '間接効果9', isAdMetric: true },
  { key: 'indirect10', label: '間接効果10', isAdMetric: true },
  { key: 'indirect_total', label: '間接効果合計', isAdMetric: true, defaultChecked: true },
  { key: 'direct_indirect_rate', label: '直間比率', isAdMetric: true },
  { key: 'first_touch', label: '初回接触', isAdMetric: true },
  { key: 'redistributed_cv', label: '再配分CV', isAdMetric: true, defaultChecked: true },

  { key: 'total_revenue', label: '売上（合計）', defaultChecked: true },
  { key: 'new_revenue', label: '新規売上', defaultChecked: true },
  { key: 'repeat_revenue', label: 'リピート売上', defaultChecked: true },
  { key: 'gross_profit', label: '粗利益', defaultChecked: true },

  { key: 'ad_cost', label: '広告コスト', isAdMetric: true, defaultChecked: true },
  { key: 'cpc', label: 'CPC', isAdMetric: true, defaultChecked: true },
  { key: 'cpa', label: 'CPA', isAdMetric: true },
  { key: 'roas', label: 'ROAS', isAdMetric: true, defaultChecked: true },
  { key: 'poas', label: 'POAS', isAdMetric: true },
];

// --- LTV detail 項目切替 catalog ---

const LTV_DETAIL_METRICS = [
  { key: 'impressions', label: '表示回数', isAdMetric: true, defaultChecked: true },
  { key: 'clicks', label: 'クリック数', isAdMetric: true, defaultChecked: true },
  { key: 'ctr', label: 'CTR', isAdMetric: true },

  { key: 'new_cv', label: '新規CV', defaultChecked: true },
  { key: 'new_cvr', label: '新規CVR', defaultChecked: true, isAdMetric: true },

  { key: 'f2_conversion_rate', label: 'F2転換率', defaultChecked: true },
  { key: 'avg_order_count', label: '平均注文回数' },

  { key: 'f1_revenue', label: '初回合計売上', defaultChecked: true },
  { key: 'new_aov', label: '新規平均売上', defaultChecked: true },
  { key: 'initial_gross_profit', label: '初回粗利益', defaultChecked: true },

  { key: 'ltv_30d_total', label: '30日合計LTV' },
  { key: 'ltv_30d', label: '30日LTV' },
  { key: 'ltv_30d_growth_rate', label: '30日LTV成長率' },
  { key: 'ltv_60d_total', label: '60日合計LTV' },
  { key: 'ltv_60d', label: '60日LTV' },
  { key: 'ltv_60d_growth_rate', label: '60日LTV成長率' },
  { key: 'ltv_90d_total', label: '90日合計LTV' },
  { key: 'ltv_90d', label: '90日LTV' },
  { key: 'ltv_90d_growth_rate', label: '90日LTV成長率' },
  { key: 'ltv_180d_total', label: '180日合計LTV' },
  { key: 'ltv_180d', label: '180日LTV' },
  { key: 'ltv_180d_growth_rate', label: '180日LTV成長率' },
  { key: 'ltv_365d_total', label: '365日合計LTV' },
  { key: 'ltv_365d', label: '365日LTV' },
  { key: 'ltv_365d_growth_rate', label: '365日LTV成長率' },

  { key: 'total_ltv', label: '合計LTV', defaultChecked: true },
  { key: 'ltv', label: 'LTV', defaultChecked: true },
  { key: 'ltv_growth_rate', label: 'LTV成長率' },

  {
    key: 'redistributed_f1_revenue',
    label: '再配分初回売上',
    isPurchasedProductAxisHidden: true,
  },
  {
    key: 'redistributed_total_ltv',
    label: '再配分合計LTV',
    isPurchasedProductAxisHidden: true,
  },

  { key: 'ad_cost', label: '広告コスト', isAdMetric: true, defaultChecked: true },
  { key: 'cpc', label: 'CPC', isAdMetric: true },
  { key: 'ncpa', label: '新規CPA', isAdMetric: true },
  { key: 'new_roas', label: '新規ROAS', isAdMetric: true, defaultChecked: true },
  { key: 'ltv_roas', label: 'LTV-ROAS', isAdMetric: true, defaultChecked: true },
  { key: 'new_troas', label: '新規TROAS', isAdMetric: true },
  { key: 'ltv_troas', label: 'LTV-TROAS', isAdMetric: true },
  { key: 'initial_poas', label: '初回POAS', isAdMetric: true, defaultChecked: true },
  { key: 'ltv_poas', label: 'LTV-POAS', isAdMetric: true, defaultChecked: true },
];

const catalogMetrics = (catalog) =>
  catalog.filter((metric) => metric.defaultChecked).map((metric) => metric.key);

const catalogMetricKeys = (catalog) => catalog.map((metric) => metric.key);

const catalogAdMetricKeys = (catalog) =>
  new Set(catalog.filter((metric) => metric.isAdMetric).map((metric) => metric.key));

const PRODUCT_ANALYSIS_METRIC_KEYS = catalogMetricKeys(PRODUCT_ANALYSIS_METRICS);
const PRODUCT_ANALYSIS_DEFAULT_METRICS = catalogMetrics(PRODUCT_ANALYSIS_METRICS);
const PRODUCT_ANALYSIS_AD_METRIC_KEYS = catalogAdMetricKeys(PRODUCT_ANALYSIS_METRICS);

const LTV_DETAIL_METRIC_KEYS = catalogMetricKeys(LTV_DETAIL_METRICS);
const LTV_DETAIL_DEFAULT_METRICS = catalogMetrics(LTV_DETAIL_METRICS);
const LTV_DETAIL_AD_METRIC_KEYS = catalogAdMetricKeys(LTV_DETAIL_METRICS);

const findAdebifyMetric = (key) =>
  PRODUCT_ANALYSIS_METRICS.find((metric) => metric.key === key)
  || LTV_DETAIL_METRICS.find((metric) => metric.key === key);

// Table/API-only keys not listed in 項目切替 catalogs.
const ADEBIFY_SUPPLEMENTAL_METRIC_LABELS = {
  cv: 'CV',
  uu: 'UU',
};

const getAdebifyMetricCatalogLabel = (key) => {
  const metric = findAdebifyMetric(key);
  if (metric) return metric.label;
  return ADEBIFY_SUPPLEMENTAL_METRIC_LABELS[key] ?? null;
};

const buildMetricOptions = (keys) =>
  keys.map((key) => ({
    value: key,
    label: getAdebifyMetricCatalogLabel(key),
  }));

const ADEBIFY_METRIC_LABEL_BY_KEY = (() => {
  const labels = { ...ADEBIFY_SUPPLEMENTAL_METRIC_LABELS };
  const add = (key, label) => {
    if (key && label && !labels[key]) labels[key] = label;
  };
  PRODUCT_ANALYSIS_METRICS.forEach((metric) => add(metric.key, metric.label));
  LTV_DETAIL_METRICS.forEach((metric) => add(metric.key, metric.label));
  return labels;
})();

// Product analysis period-trend chart: shorter axis titles where needed.
const PRODUCT_ANALYSIS_CHART_LABEL_OVERRIDES = {
  total_revenue: '売上',
  cv_total: 'CV合計',
  clicks: 'クリック',
};

const getProductAnalysisChartMetricLabel = (key) =>
  PRODUCT_ANALYSIS_CHART_LABEL_OVERRIDES[key]
  || getAdebifyMetricCatalogLabel(key);

const PRODUCT_ANALYSIS_GRAPH_METRIC_KEYS = [
  'total_revenue',
  'cv_total',
  'new_cv',
  'repeat_cv',
  'clicks',
  'impressions',
  'ad_cost',
  'cpc',
  'cpa',
  'roas',
  'poas',
  'gross_profit',
  'new_revenue',
  'repeat_revenue',
];

const PRODUCT_ANALYSIS_GRAPH_METRICS = buildMetricOptions(
  PRODUCT_ANALYSIS_GRAPH_METRIC_KEYS
);

// Product analysis detail table: 2-row grouped header layout (matches design mock).
const PRODUCT_ANALYSIS_METRIC_GROUPS = [
  { text: '広告評価', name: 'ad_eval', keys: ['impressions', 'clicks', 'ctr'] },
  {
    text: 'コンバージョン',
    name: 'conversions',
    keys: ['cv', 'cv_total', 'new_cv', 'repeat_cv', 'cvr', 'new_cvr'],
  },
  { text: '売上', name: 'revenue', keys: ['total_revenue', 'new_revenue', 'repeat_revenue', 'gross_profit'] },
  {
    text: 'LTV',
    name: 'ltv',
    keys: ['uu', 'f1_revenue', 'new_aov', 'total_ltv', 'ltv', 'ltv_growth_rate'],
  },
  { text: '費用', name: 'cost', keys: ['ad_cost', 'cpc'] },
  {
    text: '費用対効果',
    name: 'efficiency',
    keys: [
      'cpa',
      'roas',
      'poas',
      'ncpa',
      'new_roas',
      'ltv_roas',
      'new_troas',
      'ltv_troas',
      'initial_poas',
      'ltv_poas',
    ],
  },
  {
    text: '間接効果',
    name: 'indirect',
    keys: [
      'indirect_total',
      'indirect2',
      'indirect3',
      'indirect4',
      'indirect5',
      'indirect6',
      'indirect7',
      'indirect8',
      'indirect9',
      'indirect10',
      'first_touch',
      'direct_indirect_rate',
      'redistributed_cv',
    ],
  },
];

const toCustomReportMetric = (key, group, overrides = {}) => {
  const source = findAdebifyMetric(key);
  if (!source) {
    throw new Error(`Unknown Adebify metric key: ${key}`);
  }

  return {
    value: key,
    label: source.label,
    isAdMetric: Boolean(source.isAdMetric),
    group,
    ...overrides,
  };
};

// Custom report 項目切替: union of CV + LTV metrics with report-specific grouping.
// Order matches the settings panel UI (要件 custom report §).
const CUSTOM_REPORT_METRIC_ENTRIES = [
  ['cv_total', 'cv'],
  ['new_cv', 'cv'],
  ['repeat_cv', 'cv'],
  ['cvr', 'cv'],
  ['total_revenue', 'cv'],
  ['new_revenue', 'cv'],
  ['repeat_revenue', 'cv'],
  ['gross_profit', 'cv'],
  ['impressions', 'both'],
  ['clicks', 'both'],
  ['ctr', 'both'],
  ['indirect_total', 'cv'],
  ['first_touch', 'cv'],
  ['direct_indirect_rate', 'cv'],
  ['redistributed_cv', 'cv'],
  ['ad_cost', 'both'],
  ['cpc', 'both'],
  ['cpa', 'cv'],
  ['roas', 'cv'],
  ['poas', 'cv'],
  ['f1_revenue', 'ltv'],
  ['new_aov', 'ltv'],
  ['initial_gross_profit', 'ltv'],
  ['f2_conversion_rate', 'ltv'],
  ['avg_order_count', 'ltv'],
  ['ltv_30d_total', 'ltv'],
  ['ltv_30d', 'ltv'],
  ['ltv_30d_growth_rate', 'ltv'],
  ['ltv_60d_total', 'ltv'],
  ['ltv_60d', 'ltv'],
  ['ltv_60d_growth_rate', 'ltv'],
  ['ltv_90d_total', 'ltv'],
  ['ltv_90d', 'ltv'],
  ['ltv_90d_growth_rate', 'ltv'],
  ['ltv_180d_total', 'ltv'],
  ['ltv_180d', 'ltv'],
  ['ltv_180d_growth_rate', 'ltv'],
  ['ltv_365d_total', 'ltv'],
  ['ltv_365d', 'ltv'],
  ['ltv_365d_growth_rate', 'ltv'],
  ['total_ltv', 'ltv'],
  ['ltv', 'ltv'],
  ['ltv_growth_rate', 'ltv'],
  ['redistributed_f1_revenue', 'ltv', { isAdMetric: true }],
  ['redistributed_total_ltv', 'ltv', { isAdMetric: true }],
  ['ncpa', 'ltv'],
  ['new_roas', 'ltv'],
  ['ltv_roas', 'ltv'],
  ['new_troas', 'ltv'],
  ['ltv_troas', 'ltv'],
  ['initial_poas', 'ltv'],
  ['ltv_poas', 'ltv'],
];

const CUSTOM_REPORT_METRICS = CUSTOM_REPORT_METRIC_ENTRIES.map(
  ([key, group, overrides]) => toCustomReportMetric(key, group, overrides)
);

CUSTOM_REPORT_METRICS.forEach((metric) => {
  if (!ADEBIFY_METRIC_LABEL_BY_KEY[metric.value]) {
    ADEBIFY_METRIC_LABEL_BY_KEY[metric.value] = metric.label;
  }
});

const CUSTOM_REPORT_CV_METRICS = CUSTOM_REPORT_METRICS.filter(
  (metric) => metric.group === 'cv' || metric.group === 'both'
);
const CUSTOM_REPORT_LTV_METRICS = CUSTOM_REPORT_METRICS.filter(
  (metric) => metric.group === 'ltv' || metric.group === 'both'
);

const CUSTOM_REPORT_DEFAULT_CV_METRICS = ['cv_total', 'total_revenue', 'roas'];
const CUSTOM_REPORT_DEFAULT_LTV_METRICS = ['total_ltv', 'ltv', 'ltv_roas'];

// LTV metrics incompatible with period_hourly (ltv_summary_all has no hour column).
const CUSTOM_REPORT_LTV_ONLY_METRICS = new Set([
  'f1_revenue',
  'new_aov',
  'initial_gross_profit',
  'f2_conversion_rate',
  'avg_order_count',
  'ltv_30d_total',
  'ltv_30d',
  'ltv_30d_growth_rate',
  'ltv_60d_total',
  'ltv_60d',
  'ltv_60d_growth_rate',
  'ltv_90d_total',
  'ltv_90d',
  'ltv_90d_growth_rate',
  'ltv_180d_total',
  'ltv_180d',
  'ltv_180d_growth_rate',
  'ltv_365d_total',
  'ltv_365d',
  'ltv_365d_growth_rate',
  'total_ltv',
  'ltv',
  'ltv_growth_rate',
  'redistributed_f1_revenue',
  'redistributed_total_ltv',
]);

const getCustomReportMetric = (value) =>
  CUSTOM_REPORT_METRICS.find((metric) => metric.value === value);

// LTV detail table: 2-row grouped header layout (matches design mock).
const LTV_DETAIL_METRIC_GROUPS = [
  { text: '広告評価', name: 'ad_eval', keys: ['impressions', 'clicks', 'ctr'] },
  { text: 'コンバージョン', name: 'conversions', keys: ['new_cv', 'new_cvr'] },
  { text: 'リピート', name: 'repeat', keys: ['f2_conversion_rate', 'avg_order_count'] },
  {
    text: '売上・LTV',
    name: 'revenue_ltv',
    keys: [
      'f1_revenue',
      'new_aov',
      'initial_gross_profit',
      'ltv_30d_total',
      'ltv_30d',
      'ltv_30d_growth_rate',
      'ltv_60d_total',
      'ltv_60d',
      'ltv_60d_growth_rate',
      'ltv_90d_total',
      'ltv_90d',
      'ltv_90d_growth_rate',
      'ltv_180d_total',
      'ltv_180d',
      'ltv_180d_growth_rate',
      'ltv_365d_total',
      'ltv_365d',
      'ltv_365d_growth_rate',
      'total_ltv',
      'ltv',
      'ltv_growth_rate',
    ],
  },
  { text: '再配分', name: 'redist', keys: ['redistributed_f1_revenue', 'redistributed_total_ltv'] },
  {
    text: '費用対効果',
    name: 'efficiency',
    keys: [
      'ad_cost',
      'cpc',
      'ncpa',
      'new_roas',
      'ltv_roas',
      'new_troas',
      'ltv_troas',
      'initial_poas',
      'ltv_poas',
    ],
  },
];

const LTV_DETAIL_HEADER_BY_METRIC = Object.fromEntries(
  LTV_DETAIL_METRICS.map((metric) => [
    metric.key,
    {
      field: metric.key,
      name: metric.label,
      sort: 'both',
      ...(metric.isAdMetric ? { category: 'ad' } : {}),
    },
  ])
);

// --- Shared table cell formatting (domain/consts.js + custom-report pivot) ---

const ADEBIFY_CURRENCY_FIELDS = [
  'total_revenue',
  'new_revenue',
  'repeat_revenue',
  'gross_profit',
  'ad_cost',
  'cpc',
  'cpa',
  'f1_revenue',
  'new_aov',
  'total_ltv',
  'ltv',
  'ltv_30d',
  'ltv_60d',
  'ltv_90d',
  'ltv_180d',
  'ltv_365d',
  'ltv_30d_total',
  'ltv_60d_total',
  'ltv_90d_total',
  'ltv_180d_total',
  'ltv_365d_total',
  'initial_gross_profit',
  'redistributed_f1_revenue',
  'redistributed_total_ltv',
  'ncpa',
];

const ADEBIFY_PERCENTAGE_FIELDS = [
  'ctr',
  'cvr',
  'cvr_total',
  'new_cvr',
  'roas',
  'poas',
  'direct_indirect_rate',
  'ltv_growth_rate',
  'ltv_30d_growth_rate',
  'ltv_60d_growth_rate',
  'ltv_90d_growth_rate',
  'ltv_180d_growth_rate',
  'ltv_365d_growth_rate',
  'f2_conversion_rate',
  'new_roas',
  'ltv_roas',
  'new_troas',
  'ltv_troas',
  'initial_poas',
  'ltv_poas',
];

const ADEBIFY_DECIMAL_FIELDS = [
  'ctr',
  'cvr',
  'cvr_total',
  'new_cvr',
  'roas',
  'poas',
  'direct_indirect_rate',
  'ltv_growth_rate',
  'ltv_30d_growth_rate',
  'ltv_60d_growth_rate',
  'ltv_90d_growth_rate',
  'ltv_180d_growth_rate',
  'ltv_365d_growth_rate',
  'f2_conversion_rate',
  'new_roas',
  'ltv_roas',
  'new_troas',
  'ltv_troas',
  'initial_poas',
  'ltv_poas',
  'avg_order_count',
];

const ADEBIFY_NUMBER_FIELDS = [
  'impressions',
  'clicks',
  'cv',
  'cv_total',
  'new_cv',
  'repeat_cv',
  'uu',
  'indirect2',
  'indirect3',
  'indirect4',
  'indirect5',
  'indirect6',
  'indirect7',
  'indirect8',
  'indirect9',
  'indirect10',
  'indirect_total',
  'first_touch',
  'redistributed_cv',
  'avg_order_count',
  ...ADEBIFY_CURRENCY_FIELDS,
  ...ADEBIFY_PERCENTAGE_FIELDS,
];

const ADEBIFY_CURRENCY_METRICS = new Set(ADEBIFY_CURRENCY_FIELDS);
const ADEBIFY_PERCENTAGE_METRICS = new Set(ADEBIFY_PERCENTAGE_FIELDS);
const ADEBIFY_DECIMAL_METRICS = new Set([
  'avg_order_count',
  'redistributed_cv',
]);

export {
  PRODUCT_ANALYSIS_METRICS,
  PRODUCT_ANALYSIS_METRIC_KEYS,
  PRODUCT_ANALYSIS_DEFAULT_METRICS,
  PRODUCT_ANALYSIS_AD_METRIC_KEYS,
  PRODUCT_ANALYSIS_GRAPH_METRICS,
  PRODUCT_ANALYSIS_METRIC_GROUPS,
  LTV_DETAIL_METRICS,
  LTV_DETAIL_METRIC_KEYS,
  LTV_DETAIL_DEFAULT_METRICS,
  LTV_DETAIL_AD_METRIC_KEYS,
  LTV_DETAIL_METRIC_GROUPS,
  LTV_DETAIL_HEADER_BY_METRIC,
  CUSTOM_REPORT_METRICS,
  CUSTOM_REPORT_CV_METRICS,
  CUSTOM_REPORT_LTV_METRICS,
  CUSTOM_REPORT_DEFAULT_CV_METRICS,
  CUSTOM_REPORT_DEFAULT_LTV_METRICS,
  CUSTOM_REPORT_LTV_ONLY_METRICS,
  getCustomReportMetric,
  getAdebifyMetricCatalogLabel,
  getProductAnalysisChartMetricLabel,
  ADEBIFY_METRIC_LABEL_BY_KEY,
  ADEBIFY_SUPPLEMENTAL_METRIC_LABELS,
  ADEBIFY_CURRENCY_FIELDS,
  ADEBIFY_PERCENTAGE_FIELDS,
  ADEBIFY_NUMBER_FIELDS,
  ADEBIFY_DECIMAL_FIELDS,
  ADEBIFY_CURRENCY_METRICS,
  ADEBIFY_PERCENTAGE_METRICS,
  ADEBIFY_DECIMAL_METRICS,
};
